
import React from "react";
import { DashboardContent } from "@/components/dashboard/DashboardContent";
import { useDashboardData } from "@/hooks/dashboard";
import { validateOrderStatus } from "@/hooks/dashboard/dashboardUtils";

const Dashboard = () => {
  const { stats, recentOrders, factories, loading } = useDashboardData();

  if (loading) {
    return <div className="p-8 text-center">Loading dashboard data...</div>;
  }

  // Helper function to validate order status
  const validateStatus = validateOrderStatus;

  return (
    <DashboardContent 
      stats={stats} 
      recentOrders={recentOrders.map(order => ({
        id: order.id,
        customer: order.customer,
        date: order.date,
        status: validateStatus(order.status),
        amount: order.amount,
        factory: order.factory
      }))} 
      factories={factories.map(factory => ({
        name: factory.name,
        completedOrders: factory.completedOrders,
        pendingOrders: factory.pendingOrders,
        efficiency: factory.efficiency
      }))} 
    />
  );
};

export default Dashboard;
